<template>
  <div class="wrap">
    <div class="bottom-info1">
      <div class="text-section">
        <h1>设备维保</h1>
        <p>我们提供专业的设备维保服务，确保您的设备始终处于最佳运行状态。凭借经验丰富的工程师团队、快速<br />响应机制和完善的备件库，我们致力于为客户提供高效、可靠的维保解决方案。</p>
      </div>
      <div class="zupng">
        <h1>服务内容</h1>
        <p>我们为您提供全方位的设备维保服务，涵盖以下内容：</p>
      </div>


      <div class="paixubox">
        <div class="service-item top1">
          <div class="icon">
            <img src="@/assets/other/yunwei/iocn/1.png" alt="设备搬迁与安装图标">
          </div>
          <div class="contenta">
            <h3>定期巡检与保养</h3>
            <p>定期对设备进行检查和维护，预防潜在<br />故障，延长设备使用寿命</p>
          </div>
        </div>

        <div class="service-item right2">
          <div class="icon">
            <img src="@/assets/other/yunwei/iocn/3.png" alt="设备搬迁与安装图标">
          </div>
          <div class="contenta">
            <h3>设备搬迁与安装</h3>
            <p>提供专业的设备搬迁和安装服务，确保<br>设备安全、高效地投入使用</p>
          </div>
        </div>

        <div class="service-item right1">
          <div class="icon">
            <img src="@/assets/other/yunwei/iocn/6.png" alt="维保管理">
          </div>
          <div class="contenta">
            <h3>维保管理</h3>
            <p>基于ISO-9001和ITSS，围绕PPTR四要素<br />构建全方位维保体系，简化运营维护管理</p>
          </div>
        </div>

        <div class="service-item left1">
          <div class="contenta">
            <h3 style="text-align: right;">故障诊断与维修</h3>
            <p style="text-align: right;">快速定位设备故障，提供专业的维修<br />服务，恢复设备正常运行</p>
          </div>
          <div class="icon">
            <img src="@/assets/other/yunwei/iocn/2.png" alt="维保管理">
          </div>
        </div>

        <div class="service-item left2">
          <div class="contenta">
            <h3 style="text-align: right;">备件更换与升级</h3>
            <p style="text-align: right;">提供原厂备件更换服务，并根据需求<br />进行设备升级，提升设备性能</p>
          </div>
          <div class="icon">
            <img src="@/assets/other/yunwei/iocn/5.png" alt="维保管理">
          </div>
        </div>
      </div>


      <div class="icon-container">
        <img src="@/assets/other/yunwei/yuanimg.png" alt="" />
      </div>


      <div class="fuwudengji">
        <div class="zupng">
          <h1>服务等级</h1>
          <p>我们提供多种服务等级，满足不同客户的需求：</p>
        </div>
        <div class="fuwuimg">
          <img src="@/assets/other/yunwei/fuwudengji.jpg" />
        </div>
      </div>

      <div class="fuwudengji">
        <div class="zupng">
          <h1>故障等级</h1>
          <p>根据故障的紧急程度和影响范围，我们将故障分为以下等级：</p>
        </div>
        <div class="fuwuimg">
          <img src="@/assets/other/yunwei/guzhan.jpg" />
        </div>
      </div>

      <div class="fuwudengji">
        <div class="zupng">
          <h1>故障处理流程</h1>
          <p>我们的故障处理流程高效透明，确保您的设备问题得到快速解决：</p>
        </div>
        <div class="fuwuimg">
          <img src="@/assets/other/yunwei/chuli.jpg" />
        </div>
      </div>

      <br />
      <div class="liaojiebtn">
        <a href="#" class="anniubtn">
          联系我们
        </a>
      </div>





    </div>











    <div class="bottom-info1">
      <div class="text-section">
        <h1>管理服务</h1>
      </div>
    </div>

    <div class="zupingbox">
      <div class="leasing-container">
        <div class="content-row">

          <div class="text-content">
            <h2>服务介绍</h2>
            <ul>
              <li><img src="@/assets/other/element/dian.png">我们为企业提供数字化网络管理服务，保障安全稳定，支撑业务高
                <br />&nbsp;&nbsp;&nbsp;效运行。通过综合运维方案，助力组建专业团队、搭建智能平台，实现运维标准化、可视化及精细化管理。
              </li>
              <li><img
                  src="@/assets/other/element/dian.png">从人员、流程、技术、资源四维度定制方案，结合咨询-培训-部署全流程，提升运维质量与业务连续性。
              </li>
            </ul>
          </div>
          <div class="image-content tu1">
            <img src="@/assets/other/yunwei/jieshao.jpg" alt="租赁方法示意图">
          </div>
        </div>
      </div>

      <div class="fuwudengji">
        <div class="zupng">
          <h1>客户价值</h1>
          <p>我们的管理服务确保您的网络系统始终安全、稳定、高效运行，助力企业实现业务目标</p>
        </div>
        <div class="fuwuimg">
          <img src="@/assets/other/yunwei/kehujiazhi.jpg" />
        </div>
      </div>

      <div class="fuwudengji">
        <div class="zupng">
          <h1>运维服务核心内容如下</h1>
        </div>
        <div class="fuwuimg">
          <img src="@/assets/other/yunwei/hexinneirong.jpg" />
        </div>
      </div>
      <br />
      <div class="liaojiebtn">
        <a href="#" class="anniubtn">
          联系我们
        </a>
      </div>
    </div>
    <!-- <Footer :show="true" /> -->
  </div>
</template>

<script>
  import {
    getWorkList,
    getWorkYearList,
    getProductListAll
  } from "@/api/api.js";
  import Nav from "../../components/Nav/Nav.vue";
  export default {
    name: "index",
    components: {
      Nav
    },
    data() {
      return {
        jsonData: [],
        imgList: [],
        url: "/Work",
        pageSize: 100,
        currentPage: 1,
        total: 0,
        activeIndex: "1",
        paramsYear: {
          workCompetition: this.$route.query.key
        }
      };
    },
    methods: {
      getProductListAll() {
        getProductListAll({
          state: "Y"
        }).then(res => {
          this.jsonData = res.data.rows || [];
          console.log(res);
        });
      },
      getList() {
        getWorkList({}).then(res => {
          // this.imgList = res.data || [];
          console.log(res);
        });
      },
      getWorkYearList(paramsYear) {
        getWorkYearList(paramsYear).then(res => {
          this.imgList = res.data.rows || [];

          console.log(res);
        });
      },
      handleSelect(index) {
        console.log(index);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
      },
      toPage(item, index) {
        this.$router.push({
          path: "Work/wordDetail",
          query: {
            id: index,
            title: item.workTitle,
            info: item
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  // * {
  //   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  // }


  .text-section h1 {
    margin-top: 7%;
    margin-bottom: 20px;
    font-size: 44px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 55.5px;
    color: rgba(46, 49, 51, 1);
    text-align: center;
    vertical-align: top;
  }

  .bottom-info1 {
    max-width: 1440px;
    margin: 0 auto;
    padding: 30px;
    font-family: "Microsoft YaHei", sans-serif;
    background-color: #fff;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .anniubtn:hover {
    background: rgba(218, 41, 28, 1);
    display: flex;
    color: white;
  }

  .anniubtn:active {
    transform: scale(0.98);
    /* 点击时轻微缩小 */
  }

  .anniubtn {
    white-space: nowrap;
    /* 禁止文字换行 */
    transition: all 0.3s ease;
    /* 平滑过渡动画 */
    text-decoration: none;
    background-color: white;
    text-align: center;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    width: 156px;
    height: 56px;
    opacity: 1;
    border-radius: 9px;
    color: rgba(218, 41, 28, 1);
    border: 1px solid rgba(218, 41, 28, 1);
    display: flex;
    padding: 10px 40px 10px 40px;
    font-size: 18px;
    letter-spacing: 0px;
    line-height: 32px;
  }



  .fuwudengji {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    padding: 20px;
  }

  .zupng {
    align-self: flex-start;
    /* 文字左对齐 */
    width: 100%;
  }

  .fuwuimg {
    align-self: center;
    /* 图片居中 */
    width: 90%;
  }

  .fuwuimg img {
    margin-top: 2%;
  }

  .top1 {
    position: absolute;
    transform: translate(50% 50%);
    top: 8.5%;
    left: 47%;
    z-index: 999;
  }

  .left1 {
    position: absolute;
    transform: translate(50% 50%);
    top: 31%;
    left: 11.6%;
    z-index: 999;
  }

  .left2 {
    position: absolute;
    transform: translate(50% 50%);
    top: 56.5%;
    left: 14%;
    z-index: 999;
  }

  .right2 {
    position: absolute;
    transform: translate(50% 50%);
    top: 31%;
    left: 61%;
    z-index: 999;
  }

  .right1 {
    position: absolute;
    transform: translate(50% 50%);
    top: 56.5%;
    left: 57%;
    z-index: 999;
  }

  .paixubox {
    position: relative;
    height: 700px;
    /* 弹性布局且宽度由内容决定 */
  }

  .icon img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }

  .icon {
    display: flex;
    align-items: center;
    /* 确保图标自身垂直居中 */
    justify-content: center;
  }

  .service-item {

    display: flex;
    /* 使用 Flexbox 布局 */
    align-items: center;
    /* 垂直居中对齐 */
    gap: 20px;
    /* 图标和文字之间的间距 */
    margin: 0 auto;
    /* 水平居中 */
    // padding: 15px;          /* 内边距 */
  }

  .contenta h3 {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 28.8px;
    color: rgba(47, 49, 51, 1);
    text-align: left;
  }

  .contenta p {
    margin-top: 2%;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 24px;
    color: rgba(103, 103, 103, 1);
    text-align: left;
    vertical-align: top;
  }

  /* 响应式调整：小屏幕时缩小图标 */
  @media (max-width: 480px) {
    .icon img {
      width: 40px;
      height: 40px;
    }
  }











  .tu1 {
    margin-right: -200px;
  }

  .tu2 {
    margin-left: -30px;
  }

  .text-content li {
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 1.1px;
    line-height: 50px;
    color: rgba(103, 103, 103, 1);
  }

  .leasing-container ul li img {
    width: 10px;
    height: 10px;
    object-fit: contain;
    margin-top: 20px;
    margin-right: 15px;
  }

  .leasing-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 40px 20px;
  }

  .content-row {
    display: flex;
    align-items: center;
    margin-bottom: 60px;
  }

  /* 默认布局：文字左，图片右 */
  .text-content {
    flex: 1;
    padding-right: 40px;
  }

  .image-content {
    flex: 1;
  }

  .image-content img {
    width: 553.21px;
    height: 418px;
    opacity: 1;
    display: flex;
  }

  /* 反向布局：图片左，文字右 */
  .reverse {
    flex-direction: row-reverse;
  }

  .reverse .text-content {
    padding-right: 0;
    padding-left: 40px;
  }

  .text-content h2 {
    // margin-left: 30px;
    font-family: "思源黑体";
    font-size: 40px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 80px;
    color: rgba(0, 146, 214, 1);
    text-align: left;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  li {
    position: relative;
    padding-left: 30px;
    margin-bottom: 15px;
    line-height: 1.6;
    color: #444;
  }


  /* 响应式设计 */
  @media (max-width: 768px) {

    .content-row,
    .reverse {
      flex-direction: column;
    }

    .text-content {
      padding: 0 20px 20px !important;
    }

    .image-content {
      margin-top: 20px;
    }
  }

  .zupng {
    margin-top: 8%;
  }

  .zupng h1 {
    letter-spacing: 2px;
    font-size: 40px;
    font-weight: 500;
    line-height: 80px;
    color: rgba(0, 146, 214, 1);
    text-align: left;
    vertical-align: top;
  }

  .zupng p {
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 32px;
    color: rgba(103, 106, 108, 1);
    text-align: left;
    vertical-align: top;
  }

  .zupingbox {
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    padding: 30px;
    font-family: "Microsoft YaHei", sans-serif;
    background-color: #fff;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .xiantiao {
    width: 1440px;
    height: 1019px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 1795px;
    object-fit: cover;
    /* 保持比例填充 */
    object-position: center;
    /* 居中显示 */
    pointer-events: none;
    /* 防止交互影响 */
    /* 向上移动30px */

  }

  .xiantiao img {
    display: block;
    max-width: 100%;
    z-index: 2;
    object-fix: contain;
  }

  .bottom-info1 {
    max-width: 1440px;
    margin: 0 auto;
    padding: 30px;
    font-family: "Microsoft YaHei", sans-serif;
    background-color: #fff;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .text-section h1 {
    font-size: 44px;
    font-weight: 700;
    letter-spacing: 2px;
    line-height: 55.5px;
    color: rgba(46, 49, 51, 1);
    text-align: center;
  }

  .text-section p {
    margin-top: 3%;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 32px;
    color: rgba(103, 106, 108, 1);
    text-align: center;
    vertical-align: top;
  }

  .icon-container {
    top: 12.1%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    object-fit: contain;
    display: inline-flex;
    display: grid;
    place-items: center;
    /* 单行代码实现居中 */

  }

  .icon-container img {
    object-fit: contain;
    margin-top: 50px;
    width: 420px;
    height: 420px;
    opacity: 1;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }


  .hanner img {
    object-fit: cover;
    object-position: center;
  }

  .content {
    margin-top: 20px;

    .type {
      margin-top: 50px;

      .title {
        position: relative;
        width: 200px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        background-color: #5197d5;
        color: #fff;

        .line {
          display: inline-block;
          position: absolute;
          top: 22px;
          left: 20px;
          width: 15px;
          height: 3px;
          background-color: #fff;
        }
      }

      .bottom-info {
        display: flex;
        // flex-wrap: wrap;
        justify-content: stretch;

        .item {
          height: 350px;
          border: 2px solid #5197d5;
          margin-top: 20px;
          margin-right: 50px;

          img {
            width: 250px;
            height: 200px;
            margin: 0 30px;
          }

          .txt {
            width: 310px;
            height: 100px;
            margin-top: 50px;
            padding-top: 5px;
            line-height: 30px;
            font-size: 18px;
            text-align: center;
            background-color: #5197d5;
            color: #fff;
          }
        }
      }
    }
  }

  .select {
    height: 80px;
    width: 60%;
    margin: 0 auto;
  }

  .el-menu-item.is-active {
    border-bottom: 2px solid red !important;
    color: red !important;
    font-weight: bold;
  }

  .el-menu-item {
    padding: 0 43px;
  }

  .page {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }

  .img-title {
    text-align: center;
  }

  .wrap {
    text-align: left;
    width: 100%;
    height: 100%;
    position: relative;


    .imgbox {
      .box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .boxitem {
          width: 25%;
          padding-bottom: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .onde {
            width: 90%;
            height: 320px;

            .top {
              position: relative;

              .ditu {
                width: 100%;
                height: 45px;
                line-height: 45px;
                text-align: center;
                top: 175px;
                color: #ffffff;
                font-size: 14px;
                position: absolute;
                background: url("../../assets/workimg/ditu.png") no-repeat;
                background-position: center;
              }
            }

            .cont {
              font-size: 14px;
              text-align: center;
              background-color: #f5f5f5;
              padding: 20px 0;
            }

            .bottom {
              width: 100%;
              background-color: #f5f5f5;
              padding: 10px 0;
              display: flex;
              font-size: 14px;
              justify-content: space-around;
              align-items: center;

              div {
                // width: 50%;
                text-align: right;
                // padding-right: 10px;
              }
            }
          }
        }

        .boxitem:hover {
          border-bottom: 1px solid red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Work/yunwei.vue